import { AxiosError }  from "axios";
import Error           from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage    from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors          from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget     from "../../../domain/fundamentals/message/error/ErrorTarget";
import ErrorDataSource from "../../../infrastructure/datasource/error/ErrorDataSource";

class SetValidateErrorMessage {
  private readonly repository: ErrorRepository = new ErrorDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public execute(error: AxiosError) {
    if (error.response) {
      const list: Error[] = error.response.data.errors.map(error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message)));
      this.repository.set(new Errors(list));
    }
  }
}

export default SetValidateErrorMessage;
